<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none"  v-if="!fromOrganaize" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click=" backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageUsers") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
                    <div class="col-md-4 p-0">
                        <v-label>{{ $t("res_Label_SelectParentStructure") }}</v-label>
                        <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                            :showInternalStructures="true" :showExternalStructures="false"
                            :isMultiple="false" :selectedStructureUser="selectedParentStructure"
                            :disableOtherInternalEntitiesAsExternal="false"
                            @structureUserSelectChanged="parentStructureSelectChanged"
                            :addressBook_header="$t('res_Label_SelectStructure')">
                        </StructureUserSelector>
                    </div>
                    <div class="col-md-4 p-0">
                        <v-label>{{ $t("res_Label_SearchforUser") }} </v-label>
                        <v-text-field v-model="search_query" @keyup.enter="searchUsers(true)" label="" solo></v-text-field>
                    </div>
                    <!-- <div class="col-md-4 p-0">
                        <v-label>{{ $t("res_Label_SelectCompany") }} *</v-label>
                        <multi-select class="light-bg add-arrow" v-model="companyId" label="name" track-by="id"
                            open-direction="bottom" :options="company_items" :searchable="false" :loading="loading"
                            :internal-search="false" :clear-on-select="false" :close-on-select="true"
                            :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                            :multiple="false" :placeholder="$t('res_Label_Select')">
                        </multi-select>
                    </div> -->
                    <div class="col-md-4 p-0 h-100">
                        <div class="d-flex gap-2 h-100 align-items-end">
                            <v-btn color="light-blue" dense @click="clearFields()">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn color="primary" dense @click="searchUsers(true)">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn color="primary" @click="addUser()">{{ $t("res_ButtonText_AddUser") }}</v-btn>
                        </div>
                    </div> 
                </div>

                <hr>
                
                <div class="d-flex flex-1 flex-column overflow-auto">

                    <div class="d-flex flex-column">
                        <div>
                            <Pagination
                            :totalCount="pagingData.totalCount"
                            :pageSize="pagingData.pageSize"
                            :pageIndex="pagingData.pageIndex"
                            @pageIndexChanged="pageIndexChanged"
                            />
                        </div>

                        <div class="d-flex align-center pt-8 pb-8">
                            <label class="font-weight-bold mr-2">{{ $t('res_Label_OnlyDesignatedPersons') }}</label>
                            <v-checkbox class="ma-0 mr-4" v-model="onlyDesignatedPersons" hide-details dense />
                            <label class="font-weight-bold mr-2">{{ $t('res_Label_OnlyUsers') }}</label>
                            <v-checkbox class="ma-0 mr-4" v-model="onlyUsers" hide-details dense />
                            <label class="font-weight-bold mr-2">{{ $t('res_Label_OnlyDefaultDesignatedPersons') }}</label>
                            <v-checkbox class="ma-0" v-model="onlyDefaultDesignatedPersons" hide-details dense />
                        </div>
                    </div>


                    <v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" disable-sort
                        :headers="headers" :items="user_items" :loading="loading" loading-text="loading..."
                        :no-data-text="$t('res_Label_NoData')" :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
                        hide-default-footer  header-fixed :class="{'no-data': user_items.length == 0}"  :items-per-page="pagingData.pageSize">
                        <template v-slot:no-data>
                            <div>
                                <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                                <p class="m-0">{{ hasSearched ? $t("res_Msgs_NoNewItem") : $t("res_Msgs_filtersNotApplied") }}</p>
                            </div>
                        </template>

                        <template v-slot:item="row">
                            <tr>
                                <!-- <td>{{ row.item.id }}</td> -->
                                <td v-if="row.item.applicableRoleId > 0">
                                    <v-icon v-tooltip.hover="deactivationReasonTooltip(row.item)" :style="{ color: row.item.active ? '#008000' : '#F44336' }" class="mr-2">mdi-account</v-icon>
                                    <v-icon v-if="row.item.isDefaultDesignatedPerson == true" style="color: red;" class="mr-2">mdi-star-circle</v-icon>
                                    {{ row.item.name }}
                                </td>
                                <td v-else>
                                    <v-icon v-tooltip.hover="deactivationReasonTooltip(row.item)" :style="{ color: row.item.active ? '#008000' : '#F44336' }" class="mr-2">mdi-account-box-outline</v-icon>
                                    <v-icon v-if="row.item.isDefaultDesignatedPerson == true" style="color: red;" class="mr-2">mdi-star-circle</v-icon>
                                    {{ row.item.name }}
                                </td>
                                <td>{{ row.item.nameAr }}</td>
                                <td>{{ row.item.userName }}</td>
                                <td>
                                    <span v-tooltip.hover="row.item.parentNames.length > 50 ? row.item.parentNames : undefined">
                                        {{ row.item.parentNames | limitText(50) }}
                                    </span>
                                    
                                </td>
                                <td>{{ row.item.applicableRole }}</td>
                                <td class="text-start">
                                    <div class="onhover-display">
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_ChangeUserAttributes')" @click="editUser(row.item.userId)">custom-icon white-bg edit-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_ActiveOrDeActive')" @click="openChangeUserActivationStatusDialog(row.item.userId,row.item.active)"  v-model="row.item.active" >{{row.item.active ? 'mdi-account-off' : 'mdi-account-check'   }}</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-if="row.item.applicableRoleId > 0" v-tooltip.hover="$t('res_Hover_ManageUserStructures')" @click="manageUserStructure(row.item.userId)">custom-icon white-bg gear-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-if="row.item.applicableRoleId > 0" v-tooltip.hover="$t('res_Hover_SetUserPin')" @click="openChangePinCode(row.item.userId)">custom-icon white-bg code-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-if="row.item.applicableRoleId > 0" v-tooltip.hover="$t('res_Hover_ManageUserSignatures')" @click="manageUserSignatures(row.item.userId)">custom-icon white-bg pen-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-if="row.item.applicableRoleId > 0" v-tooltip.hover="$t('res_Hover_managerUserActions')" @click="managerUserActions(row.item.userId, row.item.applicableRoleId)">custom-icon white-bg edit-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-if="row.item.applicableRoleId > 0" v-tooltip.hover="$t('res_Hover_OtherSettings')" @click="openOtherSettings(row.item.userId)">mdi-cog</v-icon>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        
                    </v-data-table>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="managerUserStructureDialog" :persistent="true" content-class="fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{$t("res_DialogTitle_ManageUser's Structure")}}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="managerUserStructureDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <ManageStructures :userId="userId" :dialogModelShow="managerUserStructureDialog" v-on:closeDialog="managerUserStructureDialog = false">
                </ManageStructures>
            </div>
        </v-dialog>

        <v-dialog v-model="manageUserSignaturesDialog" content-class="fullscreen-dialog" fullscreen :persistent="true">
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{$t("res_Label_ManageSignatures")}}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="manageUserSignaturesDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <UserSignatureManager :userid="userId" :dialogModelShow="manageUserSignaturesDialog" :isAdmin="isAdmin"
                    v-on:closeDialog="manageUserSignaturesDialog = false"></UserSignatureManager>
            </div>
        </v-dialog>

    	<v-dialog v-model="changePinCodeDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_Label_SetPinCode")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="cancelPinCode">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div v-if="enableSignWithOutPinCodeFeature" class="row mb-5">
                            <div class="col-5 pt-8"><label>{{ $t("res_Label_CanSignWithoutPin") }}</label></div>
                            <div class="col-1 pt-3 pl-0 pr-0"><v-checkbox v-model="canSignWithoutPinCode" @change="updateCanSignWithoutPinCode"></v-checkbox></div>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_NewPinCode")}} <span>*</span></v-label>
                            <!-- <v-text-field label="" :disabled="canSignWithoutPinCode" solo v-model="userSecurity.newPinCode"></v-text-field> -->
                            <v-text-field label="" :disabled="canSignWithoutPinCode" solo :type="userSecurity.showNew ? 'text' : 'password'"
                                          v-model="userSecurity.newPinCode" :append-icon="userSecurity.showNew ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="userSecurity.showNew = !userSecurity.showNew" autocomplete="new-password"></v-text-field>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_ConfirmPinCode")}} <span>*</span></v-label>
                            <!-- <v-text-field label="" :disabled="canSignWithoutPinCode" solo v-model="userSecurity.confirmPinCode"></v-text-field> -->
                            <v-text-field label="" :disabled="canSignWithoutPinCode" solo :type="userSecurity.showConfirm ? 'text' : 'password'"
                                          v-model="userSecurity.confirmPinCode" :append-icon="userSecurity.showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="userSecurity.showConfirm = !userSecurity.showConfirm" autocomplete="new-password"></v-text-field>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="cancelPinCode">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1" :disabled="canSignWithoutPinCode"  @click="updatePinCode">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div> 
            </v-card>
        </v-dialog>

        <v-dialog v-model="changeUserActivationStatusDialog" content-class="dialog bg-white w-40" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_Label_ReasonForDeactivation") }} *</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="changeUserActivationStatusDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-textarea label="" solo v-model="reasonForDeactivation"></v-textarea>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="changeUserActivationStatusDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="toggleUserActivationStatus">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-overlay :value="otherSettingsDialog">
            <v-dialog v-model="otherSettingsDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">{{$t("res_Hover_OtherSettings")}}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="otherSettingsDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div class="d-flex flex-column overflow-auto h-100">
                        <div class="p-4 flex-grow-1 overflow-auto">
                            <v-list>
                                <v-list-item
                                    v-for="(action, index) in otherSettingsActions"
                                    :key="index"
                                    v-if="(index === 0 && isAdmin) || index > 0"
                                    @click="action.click()"
                                >
                                    <v-list-item-title>{{ action.label }} <span :style="{ color: action.color || 'red', fontWeight: 'bold' }">{{ action.text }}</span></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </div>
                        <v-card-actions class="top-shadow gap-3">
                            <v-btn class="light-blue flex-1"  @click="otherSettingsDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        </v-card-actions>
                    </div> 
                </v-card>
            </v-dialog>
        </v-overlay>

        <v-dialog v-model="changePasswordDialog" content-class="dialog bg-white w-40" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_Label_ResetPassword")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="changePasswordDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_NewPassword")}} <span>*</span></v-label>
                            <!-- <v-text-field label="" solo v-model="user.password"></v-text-field> -->
                            <v-text-field label="" solo :type="showPassword ? 'text' : 'password'"
                                          v-model="user.password" :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                          @click:append="showPassword = !showPassword" autocomplete="off"></v-text-field>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_ConfirmPassword")}} <span>*</span></v-label>
                            <!-- <v-text-field label="" solo v-model="user.confirmPassword"></v-text-field> -->
                            <v-text-field label="" solo :type="showConfirmPassword ? 'text' : 'password'"
                                          v-model="user.confirmPassword" :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                          @click:append="showConfirmPassword = !showConfirmPassword" autocomplete="off"></v-text-field>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="cancelPassword">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="resetPassword">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="changeProfilePicDialog" content-class="dialog bg-white w-40">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_Label_ChangeProfilePic")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="changeProfilePicDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem cursor-input">
                            <label class="mb-4">{{$t("res_Label_AttachPhoto")}} <span>*</span></label>
                            <v-file-input accept=".jpg,.jpeg,.png"  solo v-model="photoFile" prepend-icon=""></v-file-input>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="changeProfilePicDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="ChangeProfilePic">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

    	<v-dialog v-model="manageApplicationRoleDialog" content-class="fullscreen-dialog" fullscreen>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_DialogTitle_ManageApplicationRoles")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="manageApplicationRoleDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
               <ManageApplicationRoles :userId="userId" :dialogModelShow="manageApplicationRoleDialog"
                v-on:closeDialog="manageApplicationRoleDialog = false"></ManageApplicationRoles>
            </v-card>
        </v-dialog>

        <v-dialog v-model="managerUserActionsDialog" max-width="1000px" min-height="1000px">
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        <span>{{$t('res_Label_ManagePermissions')}}</span>
					</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="managerUserActionsDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<ActionSecurityRole :roleId="0" :selectedRoleId="selectedRoleId" :userId="userId" :search="Search" :seacrhvalue="SearchValue" :applicationId="applicationId" />
					</div>
				</div>
			</v-card>
		</v-dialog>

        <v-dialog v-model="upsertUserDialog" content-class="fullscreen-dialog" fullscreen>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title v-if="upsertUserDialogMode==='new'" class="p-0">{{ $t("res_DialogTitle_AddEditUser") }}</v-card-title>
                        <v-card-title v-if="upsertUserDialogMode==='edit'" class="p-0">{{ $t("res_DialogTitle_EditUser") }}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="closeUpsertUserDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div class="d-flex flex-column overflow-auto h-100">   
                        <div class="grid-3 flex-1 p-4 overflow-auto gap-2"> 
                            <div>
                                <v-label style="color: red !important">{{ $t("res_Label_FirstName") }} *</v-label>
                                <v-text-field v-model="user.firstName" label="" solo></v-text-field>
                            </div>
                            <div>
                                <v-label >{{ $t("res_Label_MiddleName") }}</v-label>
                                <v-text-field v-model="user.middleName" label="" solo></v-text-field>
                            </div>
                            <div>
                                <v-label style="color: red !important">{{ $t("res_Label_LastName") }} *</v-label>
                                <v-text-field v-model="user.lastName" label="" solo></v-text-field>
                            </div>


                            <div>
                                <v-label style="color: red !important">{{ $t("res_Label_FirstNameAr") }} *</v-label>
                                <v-text-field v-model="user.firstNameAr" label="" solo></v-text-field>
                            </div>
                            <div>
                                <v-label>{{ $t("res_Label_MiddleNameAr") }}</v-label>
                                <v-text-field v-model="user.middleNameAr" label="" solo></v-text-field>
                            </div>
                            <div>
                                <v-label style="color: red !important">{{ $t("res_Label_LastNameAr") }} *</v-label>
                                <v-text-field v-model="user.lastNameAr" label="" solo></v-text-field>
                            </div>  
                            
                            <div v-if="!user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_LoginProvider") }} *</v-label>
                                <v-select v-model="user.loginProvider" :items="loginProviders" item-text="name" item-value="id" label=""
                                    :disabled="isFetchedByAD || !canEditLoginProvider()"
                                solo return-object></v-select>
                            </div>
                            <div  v-if="user.loginProvider.id == 1 && upsertUserDialogMode == 'new' && !user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_Password") }} *</v-label>
                                <v-text-field 
                                    v-model="user.password" 
                                    label="" 
                                    solo 
                                    :type="showPassword ? 'text' : 'password'"
                                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="showPassword = !showPassword">
                                </v-text-field>
                            </div>
                            <div  v-if="user.loginProvider.id == 1 && upsertUserDialogMode == 'new' && !user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_ConfirmPassword") }} *</v-label>
                                <v-text-field 
                                    v-model="user.confirmPassword" 
                                    label="" 
                                    solo 
                                    :type="showConfirmPassword ? 'text' : 'password'"
                                    :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="showConfirmPassword = !showConfirmPassword">
                                </v-text-field>
                            </div>

                            <div v-if="!user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_Username") }} *</v-label>
                                <v-text-field v-model="user.username" label="" solo></v-text-field>
                            </div>
                            <div v-if="!user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_Email") }} *</v-label>
                                <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px;">
                                    <v-text-field
                                    v-model="user.email"
                                    label=""
                                    solo
                                    dense
                                    style="flex: 1;"
                                    ></v-text-field>
                                    <div class="d-flex justify-end">
                                        <v-tooltip bottom>
                                            <template #activator="{ on, attrs }">
                                            <v-btn class="small icon m-auto shadow-sm border p-2" style="cursor: pointer !important;" @click="fetADUserDetails(user.email)">
                                                <v-icon  v-bind="attrs"
                                                        v-on="on"
                                                        class="custom-icon hoverable-icon">mdi-check-ring</v-icon>
                                            </v-btn>
                                            </template>
                                            <div class="custom-tooltip">
                                            {{ $t('res_Tooltip_FetchADUser') }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!user.isExternalContact">
                                <v-label>{{ $t("res_Label_Gender") }}</v-label>
                                <v-select v-model="user.gender" :items="genderTypes" item-text="name" item-value="id" class="input-text-color" label="" solo return-object></v-select>
                            </div>
                            <div>
                                <v-label>{{ $t("res_Label_Title") }}</v-label>
                                <v-text-field v-model="user.title" label="" solo></v-text-field>
                            </div>
                            <div v-if="!user.isExternalContact">
                                <v-label>{{ $t("res_Label_Manager") }}</v-label>
                                <MultiSelect v-model="user.manager" class="light-bg add-arrow" label="name" track-by="id"
                                    open-direction="bottom" :options="managers" :searchable="true" :loading="loading"
                                    :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                    :options-limit="300" :max-height="600" :show-no-results="false" :placeholder="$t('res_Label_Select')"
                                    :hide-selected="false" :multiple="false" @search-change="asyncFindManager"
                                    @close="managers = []">
                                    <template slot="option" slot-scope="props">
                                        <div >
                                            <div class="" style="">
                                                <v-avatar color="#eff2f5" size="40">{{
                                                    CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                            </div>
                                            <div class="ad__box" v-if="props.option.isUser">
                                                <p class="ad__text__bold">{{ props.option.name }}</p>
                                                <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                                </p>
                                            </div>
                                            <div class="ad__box" v-else>
                                                <p class="ad__text__bold">{{ props.option.name }}</p>
                                                <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="noOptions" slot-scope="props">
                                        {{ $t("res_Msgs_EmptySearch") }}
                                    </template>
                                </MultiSelect>
                            </div>
                            <div v-if="!user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_ApplicableRole") }} *</v-label>
                                <!-- <v-select v-model="user.applicationRole" :items="applicationRoles" item-text="name" item-value="id" label="" solo return-object></v-select> -->
                                <MultiSelect class="light-bg add-arrow" v-model="user.applicationRole" :placeholder="$t('res_Label_Select')"
                                    label="name" track-by="id" open-direction="bottom" :options="applicationRoles"
                                    :searchable="true" :loading="loading" :internal-search="true" dense
                                    :clear-on-select="true" :close-on-select="true" :options-limit="300" 
                                    :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                    return-object>
                                </MultiSelect>
                            </div>
                            <div>
                                <v-label>{{ $t("res_Label_TitleAr") }}</v-label>
                                <v-text-field v-model="user.titleAr" label="" solo></v-text-field>
                            </div>
                            <div>
                                <v-label style="color: red !important">{{ $t("res_Label_Profession") }} *</v-label>
                                <textarea v-model="user.profession" label="" class="customTextarea input-text-color" solo style="min-height: 90px"></textarea>
                            </div>
                            <div>
                                <v-label style="color: red !important">{{ $t("res_Label_ProfessionAr") }} *</v-label>
                                <textarea v-model="user.professionAr" label="" class="customTextarea input-text-color" solo style="min-height: 90px"></textarea>
                            </div>
                            <div v-if="upsertUserDialogMode === 'new' && !user.isExternalContact">
                                <div>
                                    <v-label style="color: red !important">{{ $t("res_Label_Structure") }} *</v-label>
                                    <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                        :showInternalStructures="true"
                                        :showExternalStructures="false"
                                        :isMultiple="false" :selectedStructureUser="user.structure"
                                        :disabled="fromOrganaize"
                                        :disableOtherInternalEntitiesAsExternal="false"
                                        @structureUserSelectChanged="structureUserSelectChanged" :addressBook_header="$t('res_Label_SelectStructure')">
                                    </StructureUserSelector>
                                </div>
                            </div>
                            <div v-if="upsertUserDialogMode === 'new' && !user.isExternalContact">
                                <v-label style="color: red !important">{{ $t("res_Label_PrivacyLevel") }} *</v-label>
                                <v-select v-model="user.privacyLevel" :items="privacies" item-text="name" item-value="id" label="" solo return-object></v-select>
                            </div>
                            <div>
                                <v-label>{{ $t("res_GridHeaders_Salutation") }}</v-label>
                                <v-text-field v-model="user.salutation" label="" solo></v-text-field>
                            </div>

                            <div v-if="upsertUserDialogMode === 'new' && !user.isExternalContact">
                                <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_IsStructureReciever') }}</v-label>
                                <v-checkbox class="mb-0 mt-0" v-model="user.isStructureReceiver" solo></v-checkbox>
                            </div> 
                            <div v-if="(upsertUserDialogMode !== 'new' && user.isExternalContact) ">
                                <v-label class="mt-3 mb-0">{{ $t('res_Label_IsDesignatedPerson') }}</v-label>
                                <v-checkbox class="mb-0 mt-0" v-model="user.isDesignatedPerson" solo></v-checkbox>
                            </div>
                            <div>
                                <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_Active') }}</v-label>
                                <v-checkbox class="mb-0 mt-0" v-model="user.active" solo></v-checkbox>
                            </div>
                            <div>
                                <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_IsExternalContact') }}</v-label>
                                <v-checkbox class="mb-0 mt-0" v-model="user.isExternalContact" solo></v-checkbox>
                            </div>
                            <div v-if="user.isExternalContact">
                                <v-label class="mt-3 mb-0">{{ $t('res_Label_IsDefaultDesignatedPerson') }}</v-label>
                                <v-checkbox class="mb-0 mt-0" v-model="user.isDefaultDesignatedPerson" solo></v-checkbox>
                            </div>
                        </div>
                        <v-card-actions class="gap-2 sticky-actions">
                            <v-spacer></v-spacer>
                            <v-btn class="light-blue" style="min-width: 100px !important;" @click="closeUpsertUserDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                            <v-btn class="primary" style="min-width: 100px !important;" @click="upsertUser()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                        </v-card-actions>
                    </div>
                </v-card>
        </v-dialog>

    </div>
</template>

<script>
import axios from 'axios';
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import MultiSelect from 'vue-multiselect'
import ManageStructures from '@/components/ManageStructures.vue';
import ManageApplicationRoles from '@/components/ManageApplicationRoles.vue';
import Pagination from '@/components/Pagination.vue'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import UserSignatureManager from '@/components/UserSignatureManager.vue'
import ActionSecurityRole from '@/components/ActionSecurityRole.vue'

export default {
    name: 'ManageUsers',
    components: { MultiSelect, ManageStructures, ManageApplicationRoles, Pagination, StructureUserSelector,UserSignatureManager,ActionSecurityRole  },
    data: function () {
        return {
            onlyDesignatedPersons: false,
            onlyDefaultDesignatedPersons: false,
            onlyUsers: false,
            showReasonForDeactivation: window.showReasonForDeactivationInManageUsers,
            isActive: false,
            reasonForDeactivation: "",
            changeUserActivationStatusDialog: false,
            canSignWithoutPinCode: false,
            enableSignWithOutPinCodeFeature: window.enableSignWithOutPinCodeFeature,
            loading: false,
            search_query: '',
            companyId: null,
            selectedParentStructure: null,
            parentStructureId: null,
            user_items: [],
            company_items: [],
            userId: 0,
            manageApplicationRoleDialog: false,
            managerUserActionsDialog:false,
            options: ['list', 'of', 'options'],
            headers: [
                // { text: 'Id', value: 'id' },
                { text: this.$t("res_GridHeaders_Name"), value: 'name'},
                { text: this.$t("res_GridHeaders_NameAr"), value: 'nameAr'},
                { text: this.$t("res_Label_Username"), value: 'userName'},
                { text: this.$t("res_GridHeaders_Structure"), value: 'parentName'},
                { text: this.$t("res_GridHeaders_ApplicableRole"), value: 'applicableRole'},
                { text: this.$t("res_Label_AvailableActions"), value: 'actions', sortable: false, width: '260px'  },
            ],
            upsertUserDialogMode: 'new',
            upsertUserDialog: false,
            managerUserStructureDialog: false,
            changePinCodeDialog: false,
            otherSettingsDialog :false,
            showAddSignatureDialog: false,
            EditSignatureDialog:false,
            manageUserSignaturesDialog: false,
            loginProviders: [{ id: '11', name: 'Active Directory' }],
            genderTypes: [ { id: undefined, name: 'Not Selected'},{ id: 'M', name: 'Male' }, { id: 'F', name: 'Female' }],
            managers: [],
            structures: [],
            privacies: [],
            applicationRoles: [],
            user:
            {
                loginProvider: { id: 11, name: 'Active Directory' },
                password: '',
                confirmPassword: '',
                firstName: '',
                middleName: '',
                lastName: '',
                firstNameAr: '',
                middleNameAr: '',
                lastNameAr: '',
                username: '',
                email: '',
                gender: { id: undefined, name: 'Not Selected'},
                active: true,
                manager: {},
                structure: {},
                title: '',
                titleAr: '',
                profession: '',
                professionAr: '',
                salutation: '',
                isExternalContact: false,
                hasSingleApprovalPermission: false,
                isStructureReceiver: false,
                privacyLevel: {},
                isDesignatedPerson: false,
                isDefaultDesignatedPerson: false,
                applicationRole: {},
                showNew: false,
                showConfirm: false
            },
            userSecurity:
            {
                showCurrentPinCode: false,
                newPinCode: '',
                confirmPinCode: '',
                showNew: false,
                showConfirm: false
            },
            signatureheaders: [
                { text: 'Id', value: 'id', sortable: false, align: ' d-none' },
                { text: this.$t("res_GridHeaders_Image"), value: 'thumbnail', sortable: false },
                { text: this.$t("res_GridHeaders_SignatureName"), value: 'name', sortable: false },
                { text: this.$t("res_GridHeaders_DefaultSignature"), value: 'isDefault', sortable: false },
                { text: '', value: '', sortable: false, width: '60px' },
            ],
            userSignature: {
                selectedSignatures: [],
                signatureName: '',
                signatureFile: {},
                isDefault: false,
                uploadDocument: [
                    value => !!value || 'Please upload signature'
                ],
            },
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            client_version_Id: constants.client_version_Id,
            applicationId: 1,
			Search:"",
			SearchValue:"",
            photoFile: {},
            editingUserId: 0,
            changePasswordDialog: false,
            otherSettingsActions: [
                {
                    label: this.$t('res_Label_ResetPassword'),
                    click: this.openChangePassword,
                    text: '' 
                },
                {
                    label: this.$t('res_Label_PasswordExpiration'),
                    text: '',
                    click: 'password'
                }
            ],
            changeProfilePicDialog: false,
            roleId: JSON.parse(sessionStorage.getItem("user")).profile.ApplicationRoleId,
            isAdmin: false,
            canSeeAllCompanies: false,
            selectedRoleId: 0,
            showPassword: false,
            showConfirmPassword: false,
            isFetchedByAD: false,
            hasSearched: false
        }
    },
    props: {
        structureId1: {type : Number, default: 0},
        fromOrganaize  : {type : Boolean, default: false},
        enableIntialFetchingUsers  : {type : Boolean, default: false},
        structureProps: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        canEditLoginProvider() {
            return constants.isFullAdmin != null && constants.isFullAdmin !== false;
        },
        async fetADUserDetails(email)
        {
            if(email != null && email != undefined && email != "")
            {
                window.showLoading();
                axios.get(constants.baseApiUrl + "Admin/GetActiveDirectoryUserDetails?email=" + email)
                    .then((res) => {
                        this.isFetchedByAD = true;
                        var currentStructure = this.user.structure;
                        this.user = res.data;
                        this.user.gender = { id: undefined, name: 'Not Selected'};
                        this.user.loginProvider = this.loginProviders.find(x => x.id == 11);
                        this.user.active = true;
                        this.user.structure = currentStructure;
                        window.hideLoading()
                        this.company_items = res.data
                    }
                ).catch((err) => {
                    window.hideLoading()
                    console.warn(err)
                })
            }
            else
            {
                window.showAlert(this.$t('res_Label_EnterEmailAddress'), 'warning')
            }
        },
        async fetADUserPasswordExpiry(userId)
        {
            window.showLoading();
            axios.get(constants.baseApiUrl + "Admin/GetActiveDirectoryPasswordExpiry?userId=" + userId)
                .then((res) => {
                    var value = this.otherSettingsActions.find(x => x.click === 'password');
                    value.text = res.data
                    value.color = res.data <= 0 ? 'red' : 'green'
                    window.hideLoading()
                }
            ).catch((err) => {
                window.hideLoading()
                console.warn(err)
            })
        },
        isFileTypeValid()
        {
            const file = this.photoFile;
            return file && file.type.startsWith('image/');
        },
        async ChangeProfilePic()
        {
            if (this.userId == 0 || this.photoFile == null)
            {
                window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                return
            }
            const isFileTypeValid = this.isFileTypeValid();
            if (isFileTypeValid == false || isFileTypeValid == null) {
                window.showAlert(this.$t('res_Msgs_FileMustBeImage'), 'warning');
                this.photoFile = {};
                return;
            }
            window.showLoading();
            this.readFile(this.photoFile, async (fileByteArray) => {
                    const formData = new FormData();
                    formData.append('file', new Blob([new Uint8Array(fileByteArray)], { type: 'application/octet-stream' }));
                    const attachmentId = await this.uploadPhoto(formData);
                    this.changeUserPhotoAttachmentId(this.userId, attachmentId);
                    this.changeProfilePicDialog = false;
                    window.hideLoading();
            });
        },
        openChangePassword()
        {
            this.changePasswordDialog = true;
        },
        async openChangeProfilePic()
        {
            const res = await axios.get(constants.baseApiUrl + "Admin/GetUser?userId=" + this.userId);
            this.photoFile = await this.getPhotoFile(res.data.photoAttachmentId);
            this.changeProfilePicDialog = true;
        },
        async readFile(file, successHandler) {
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    successHandler(fileByteArray);
                }
            }
        },
        disableAnyTouchMove(){
            return false;
        },
        getCompaniesForUser: function () {
            axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
                .then((res) => this.company_items = res.data)
                .catch((err) => console.warn(err))
        },
        getLoginProviders: function () {
            window.showLoading()
            axios.get(constants.baseApiUrl + "Admin/ListLoginProviders")
                .then((res) => this.loginProviders = res.data)
                .catch((err) => console.warn(err))
                .finally(() =>  window.hideLoading())
        },
        checkArabicEvent(e)
        {
            if (e.ctrlKey || e.metaKey) 
                {
                    return;
                }  
                let inputChar = e.key;  
                if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Shift', 'CapsLock', 'Escape', 'Alt' , 'Unidentified'].includes(inputChar)) {
                    return;
                } 

                if (englishCharRegex.test(inputChar)) {
                    e.preventDefault();
                    window.showAlert(this.$t('res_Msgs_NotValidArabicName'), 'warning');
                } 
        },
         checkEnglishEvent(e)
        {
            if (e.ctrlKey || e.metaKey) {
                    return;
                }  
                let inputChar = e.key;  
                if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Shift', 'CapsLock', 'Escape', 'Alt' , 'Unidentified'].includes(inputChar)) {
                    return;
                } 

                if (!englishCharRegex.test(inputChar)) {
                    e.preventDefault(); 
                    window.showAlert(this.$t('res_Msgs_NotValidArabicName'), 'warning');
                } 
        },
        searchUsers: function (isResetPaging) {
            if (isResetPaging) {
                this.pagingData.totalCount = 0;
                this.pagingData.pageIndex = 0;
            }

            // if (this.companyId == null || this.companyId == undefined || this.companyId.id == undefined || this.companyId.id == null) {
            //     window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
            //     return
            // }

            //Incase of calling direct Manage Users this.structureId1 never set

            var profileCompanyId = JSON.parse(sessionStorage.getItem("user")).profile.CompanyId; 
            
            var compId = this.fromOrganaize ? this.structureId1 : (profileCompanyId != null && profileCompanyId != undefined) ? profileCompanyId : 0;

            var structureId = this.canSeeAllCompanies ? 0 : (this.structureId1 != 0) ? this.structureId1 :
                (profileCompanyId != null && profileCompanyId != undefined) ? profileCompanyId : 0

            // Only include parentStructureId when a structure is actually selected.
            var parentIdParam = (this.parentStructureId != null && this.parentStructureId != '') ? `&parentStructureId=${this.parentStructureId}` : '';

            window.showLoading()
            let params = `?query=${this.search_query}&companyId=${compId}&getCountOnly=false`
                + `&pageIndex=${this.pagingData.pageIndex}&pageSize=${this.pagingData.pageSize}&structureId=${structureId}`
                + `&fromOrganaize=${this.fromOrganaize}&onlyDesignatedPersons=${this.onlyDesignatedPersons}&onlyUsers=${this.onlyUsers}&onlyDefaultDesignatedPersons=${this.onlyDefaultDesignatedPersons}${parentIdParam}`;

            axios.get(constants.baseApiUrl + "Admin/SearchUsersGrouped" + params)
                .then((res) =>
                {
                    this.user_items = res.data

                    let params_Count = `?query=${this.search_query}&companyId=${compId}&getCountOnly=true`
                        + `&structureId=${structureId}&applicationId=${constants.defaultApplicationId}&fromOrganaize=${this.fromOrganaize}`
                        + `&onlyDesignatedPersons=${this.onlyDesignatedPersons}&onlyUsers=${this.onlyUsers}&onlyDefaultDesignatedPersons=${this.onlyDefaultDesignatedPersons}${parentIdParam}`;
                    
                    axios.get(constants.baseApiUrl + "Admin/SearchUsersGrouped" + params_Count)
                        .then((res) => 
                        {
                            this.pagingData.totalCount = res.data
                        })
                        .catch((err) => console.warn(err))
                })
                .catch((err) => console.warn(err))
                .finally(() =>
                {
                    this.hasSearched = true;
                    window.hideLoading();
                });
        },
        backToAdminPage(){
            router.push({ name: 'admin' })
        },
        clearFields() {
            this.search_query = ''
            this.companyId = {}
            this.selectedParentStructure = null
            this.parentStructureId = null
            this.hasSearched=false
            this.user_items=[];
        },
        parentStructureSelectChanged(item) {
            this.selectedParentStructure = item;
            this.parentStructureId = (item && item.id) ? item.id : null;
        },
        async getRoles() {

            window.showLoading();
            axios.get(constants.baseApiUrl + 'Document/get-all-roles')
            .then((res) => {
                constants.isApplicaitonRolesLoaded = true;

                if (res.data) {
                    constants.applicationRoles = res.data;

                    if (!this.isAdmin)
                        this.applicationRoles = constants.applicationRoles.filter(x => x.id != 1 && x.id != 2);
                    else
                        this.applicationRoles = constants.applicationRoles;
                }
            })
            .catch((err) => {console.warn(err);})
            .finally(() => { window.hideLoading();});
        },
        async addUser() {
            if(this.applicationRoles.length == 0)
                await this.getRoles();

            if(this.loginProviders.length == 0)
                await this.getLoginProviders();

            window.showLoading();
            if(this.privacies.length == 0)
                this.privacies = constants.privacies;
            
            this.upsertUserDialogMode = 'new'

            if(this.roleId == 11)
            {
                this.user.loginProvider = this.loginProviders.find(x => x.id == 11);
                this.isFetchedByAD = true;
            }

            this.upsertUserDialog = true
            window.hideLoading();
        },
        getPhotoFile(photoAttachmentId)
        {
            if (photoAttachmentId == null || photoAttachmentId == undefined)
                return null;
            axios.get(constants.baseApiUrl + "Attachment/GetAttachmentData?attachmentId=" + photoAttachmentId)
                .then((res) => {
                    var blob = new Blob([new Uint8Array(res.data.item3)], { type: res.data.item1 });
                    this.photoFile = new File([blob], res.data.item2, { type: res.data.item1 });
                })
                .catch((err) => console.warn(err));
        },
        async editUser(userId) {
            this.editingUserId = userId;

            if (this.applicationRoles.length === 0)
                await this.getRoles();

            if (this.loginProviders.length === 0)
                await this.getLoginProviders();

            if (this.privacies.length === 0)
                this.privacies = constants.privacies;

            window.showLoading();
            axios.get(constants.baseApiUrl + "Admin/GetUser?userId=" + userId)
                .then((res) => {
                    if (res == null || res.data == null)
                        return;

                    this.user = res.data;

                    if (this.user.loginProvider != null) {
                        this.user.loginProvider.id = parseInt(this.user.loginProvider.id);
                    }

                    this.upsertUserDialogMode = "edit";
                    this.upsertUserDialog = true;
                })
                .catch((err) => { console.warn(err); })
                .finally(() => { window.hideLoading(); });
        },
        async uploadAttachmentData(formData) {
            try {
                const res = await axios.post(constants.baseApiUrl + 'Attachment/UploadAttachmentData', formData);
                return res.data;
            } catch (err) {
                return 0;
            }
        },
        async uploadPhoto(formData) 
        {
            const attachmentDataId = await this.uploadAttachmentData(formData);

            const fileName = this.photoFile.name.split('.').slice(0, -1).join('.');
            const fileExtension = this.photoFile.name.split('.').pop();
            const size = this.photoFile.size;
            const contentType = this.photoFile.type;

            const photoAttachmentDto = {
                AttachmentDataId: attachmentDataId,
                name: fileName,
                extension: fileExtension,
                size: size,
                contentType: contentType,
            };
            const res = await axios.post(constants.baseApiUrl + 'Attachment/UploadPhotoAttachment', photoAttachmentDto);
            return res.data;
        },
        changeUserPhotoAttachmentId(userId, attachmentId) 
        {
            axios.post(constants.baseApiUrl + 'User/UpdatePhotoAttachment?userId=' + userId + '&attachmentId=' + attachmentId)
                .then((res) => 
                {
                    if (res.data)
                        window.showAlert(this.$t('res_Msgs_ProfilePicUpdatedSuccess'), 'success');
                    else
                        window.showAlert(this.$t('res_Msgs_ProfilePicUpdatedFail'), 'error');
                })
                .catch((err) => console.warn(err));
        },
        async upsertUser() {
            if(!this.user.isExternalContact){
                var isFormValid = true

                if (this.user.firstName == '' || this.user.lastName == '' || this.user.firstNameAr == '' || this.user.lastNameAr == ''
                    || this.user.firstName == null || this.user.lastName == null || this.user.firstNameAr == null || this.user.lastNameAr == null)
                    isFormValid = false

                if (this.user.username == '' || this.user.email == '' || this.user.profession == '' || this.user.professionAr == ''
                    || this.user.username == null || this.user.email == null || this.user.profession == null || this.user.professionAr == null)
                    isFormValid = false

                if (this.upsertUserDialogMode == 'new') {
                    if (this.user.structure?.id == null || this.user.structure?.id == undefined)
                        isFormValid = false

                    if (this.user.privacyLevel.id == undefined || this.user.privacyLevel.id == null )
                        isFormValid = false
                }

                if (this.user.applicationRole == null || this.user.applicationRole == undefined || this.user.applicationRole.id == undefined 
                        || this.user.applicationRole.id == null)
                    isFormValid = false

                if (isFormValid == false) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    return
                }

                if (!this.validateEmail(this.user.email)) {
                    window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                    return
                } 
            
                if (this.upsertUserDialogMode == 'new' && this.user.loginProvider.id == 1) {
                    if (this.user.password == '' || this.user.confirmPassword == '') {
                        window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                        return
                    }
                    if (this.user.password != this.user.confirmPassword) {
                        window.showAlert(this.$t("res_Msgs_MatchPassword"), 'warning')
                        return
                    }
                    const password = this.user.password;
                    const passwordRegex = /^(?=.*[@#$%^&+=!]).{10,}$/u;

                    if (!passwordRegex.test(password)) {
                        window.showAlert(this.$t("res_Msgs_PasswordRequirements"), 'warning');
                        return
                    }
                }
                window.showLoading()
                axios.post(constants.baseApiUrl + "Admin/UpsertUser", this.user)
                    .then(response => {
                        if (response.data.item1 == true) {
                            window.showAlert(this.$t('res_Msgs_SuccessfullySaved'), 'success');
                            this.closeUpsertUserDialog();
                            this.searchUsers(true);
                        } else {
                            if (response.data.item2 == 'UsernameAlreadyExists')
                                window.showAlert(this.$t("res_Msgs_AlreadyExists"), 'warning');
                            else
                                window.showAlert(response.data.item2, 'error');
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading());
            }
            else{
                this.upsertExternalUser()
            }    
        },
        async upsertExternalUser() {
            const dp = this.user;

            if (!dp?.firstName || !dp?.lastName || !dp?.firstNameAr || !dp?.lastNameAr || !dp?.profession || !dp?.professionAr) 
            {
                window.showAlert('res_Msgs_FillRequired', 'warning');
                return;
            }

            if(this.user.email && this.user.email != ""  ) 
            {
                const isValidEmail = /^((?!@)[\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)([\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)?@((?!@)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(\.[a-zA-Z]{2,})$/.test(this.user.email);
                    
                if(!isValidEmail){
                    window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                    return;
                }
            }
                

            if(!this.user.email){
                this.user.email = '';
            }

            //this.user.isDefaultDesignatedPerson = true

            if(this.user.structure != null && this.user.structure != undefined)
                this.user.structureId = this.user.structure?.id ?? null;
            
            this.user.isUser = true
            utils.defaultPost('Document/AddEditDesignatedPerson', this.user,
                (res) => {
                    if (res.data.item1 > 0) {

                        if(res.data.item2 == 1)
                        {
                            window.showAlert('res_Msgs_DesignatedAddSuccess', 'success');
                        }
                        else if(res.data.item2 == 2)
                        {
                            window.showAlert('res_Msgs_DesignatedEditSuccess', 'success');
                        }
                        this.closeUpsertUserDialog();
                    this.searchUsers(true); 
                    }
                },
                this.handleError, true);		
            },
        validateEmail(email) {
            // Check if email contains only spaces
            if (email.trim() === "")
                return false;

            // Check if email contains '@' character
            if (!email.includes('@'))
                return false;

            // Check if email contains '@@'
            if (email.includes('@@'))
                return false;

            // Check if email contains spaces
            if (/\s/.test(email))
                return false;

            // Split email into local and domain parts
            const [localPart, domainPart] = email.split('@');

            // Check if local part is empty or starts/ends with a dot
            if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                return false;

            // Check if domain part is empty or starts/ends with a dot
            if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                return false;

            // Check if domain part contains a dot (to ensure a top-level domain is present)
            if (!domainPart.includes('.'))
                return false;

            // Regular expression to check for a valid domain
            const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

            // Regular expression to check for a valid IP address
            const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

            // Check if domain part is an invalid IP address
            if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                return true;
            else
                return false;

            return true;
        },
        openChangeUserActivationStatusDialog(_userId, isActive) {
            this.userId = _userId;
            this.isActive = isActive;
            if(this.isActive && this.showReasonForDeactivation)
            {       
                this.changeUserActivationStatusDialog = true;
            }
            else
            {
                window.showInformation(this.$t('res_Msgs_Confirmation'), isActive ? this.$t('res_Msgs_UserDeActiveConfirmation') : this.$t('res_Msgs_UserActiveConfirmation'), () => {
                this.toggleUserActivationStatus()
                }, () => { });
            }
        },
        deactivationReasonTooltip(item)
        {
            if(item.active || !item.reasonForDeactivation || item.reasonForDeactivation.trim() == "")
                return undefined
            return this.$t('res_Label_ReasonForDeactivation') + ': ' + item.reasonForDeactivation
        },
        toggleUserActivationStatus()
        {
            let reason = this.reasonForDeactivation.trim()
            if(this.isActive && this.showReasonForDeactivation && reason == "")
            {
                window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                return
            }
            window.showLoading()
            axios.get(constants.baseApiUrl + "Admin/ToggleUserActivationStatus?userId=" + this.userId + "&reasonForDeactivation=" + encodeURIComponent(reason))
            .then((res) => {
                if(res != null && res != undefined)
                {
                    this.changeUserActivationStatusDialog = false;
                    this.reasonForDeactivation = "";
                    let item = this.user_items.find(x=>x.userId == this.userId)
                    item.active = res.data
                    if(reason != "")
                        this.$set(item, 'reasonForDeactivation', reason)
                    window.showAlert( (this.isActive ? this.$t("res_Msgs_UserDeActive") : this.$t("res_Msgs_UserActive") ) , 'success');
                }
            })
            .catch((err) => console.warn(err))
            .finally(() => window.hideLoading());
        },
        manageUserStructure(userId) {
            this.userId = userId;
            this.managerUserStructureDialog = true;
        },
        openChangePinCode(userId) {
            this.userId = userId;
            this.changePinCodeDialog = true;
            this.fetchCanSignWithoutPin()
        },
        async fetchCanSignWithoutPin()
        {
            try {
                const response = await axios.get(constants.baseApiUrl + 'User/GetCanSignWithoutPinCodeByUserId?userId='+this.userId);
                const responseData = response.data;
                this.canSignWithoutPinCode =  responseData && this.enableSignWithOutPinCodeFeature;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        },
        async updateCanSignWithoutPinCode()
        {
            try {
                window.showLoading()
                var response = await axios.post(constants.baseApiUrl + 'User/UpdateCanSignWithoutPinCodeByUserId?canSignWithoutPinCode=' + this.canSignWithoutPinCode+'&userId='+this.userId);
                this.canSignWithoutPinCode = response.data ? true : false
                if(this.canSignWithoutPinCode)
                    window.showAlert(this.$t('res_Msgs_SignWithoutPinCodeEnabled'), 'success')
                else
                    window.showAlert(this.$t('res_Msgs_SignWithoutPinCodeDisabled'), 'success')

                this.userSecurity.newPinCode = ''
                this.userSecurity.confirmPinCode = ''
            }
            catch (error) {
                console.log(error);
            }
            finally {
                window.hideLoading()
            }
        },
        openOtherSettings(userId)
        {
            this.userId = userId;
            this.fetADUserPasswordExpiry(userId)
            this.otherSettingsDialog = true;
        },
        cancelPassword() {
            this.user.password = '';
            this.user.confirmPassword = '';
            this.changePasswordDialog = false;
        },
        resetPassword() {
            if (this.user.password == '' || this.user.confirmPassword == '') {
               window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                return
            }
            if (this.user.password != this.user.confirmPassword) {
                window.showAlert(this.$t("res_Msgs_MatchPassword"), 'warning')
                return
            }
            const password = this.user.password;
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.{10,})/;

            if (!passwordRegex.test(password)) {
                window.showAlert(this.$t("res_Msgs_PasswordRequirements"), 'warning');
                return
            }
            axios.post(constants.baseApiUrl + `Admin/ChangeUserPassword?userId=${this.userId}&newPassword=${this.user.password}`, null)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert(this.$t("res_Msgs_PasswordUpdateSuccess"), 'success')
                        this.user.password = ''
                        this.user.confirmPassword = ''
                        this.otherSettingsDialog = false
                        this.changePasswordDialog = false
                    }
                    else {
                        window.showAlert(this.$t("res_Msgs_WrongPassword"), 'warning')
                    }
                })
                .catch((err) => console.warn(err));
        },
        cancelPinCode() {
            this.userSecurity.showCurrentPinCode = false 
            this.userSecurity.showNew = false
            this.userSecurity.showConfirm = false;
            this.userSecurity.newPinCode = ''
            this.userSecurity.confirmPinCode = ''
            this.changePinCodeDialog = false
            this.canSignWithoutPinCode = false
        },
        updatePinCode() {
            if (this.userSecurity.newPinCode == '' || this.userSecurity.confirmPinCode == '') {
                window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                return
            }

            if (this.userSecurity.newPinCode != this.userSecurity.confirmPinCode) {
                window.showAlert(this.$t("res_Msgs_MatchPassword"), 'warning')
                return
            }

            axios.post(constants.baseApiUrl + "Admin/ChangeUserPinCode?userId=" + this.userId + "&newPinCode=" + this.userSecurity.newPinCode, null)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert(this.$t("res_Msgs_PinUpdateSuccess"), 'success')
                        this.userSecurity.showCurrentPinCode = false 
                        this.userSecurity.newPinCode = ''
                        this.userSecurity.confirmPinCode = ''
                        this.changePinCodeDialog = false
                    }
                    else {
                        window.showAlert(this.$t("res_Msgs_EmptyPin"), 'warning')
                    }
                })
                .catch((err) => { console.warn(err); window.showAlert(this.$t("res_Msgs_PinUpdateError"), 'error'); });
        },
        manageUserSignatures(userId) {
            this.userId = userId
           	
            this.manageUserSignaturesDialog = true
        },

        async readFile(file, successHandler) {
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    successHandler(fileByteArray);
                }
            }
        },
        manageAppRole(fullUserId) {
            var userId = fullUserId.split('-')[0];
            this.userId = userId;
            this.manageApplicationRoleDialog = true;
        },
        managerUserActions(userId, roleId){
            //var userId = fullUserId.split('-')[0];
            this.userId = userId;
            this.selectedRoleId = roleId;
            this.managerUserActionsDialog = true;
        },
        closeUpsertUserDialog() {
            this.user = {
                loginProvider: { id: 11, name: 'Active Directory' },
                password: '',
                confirmPassword: '',
                firstName: '',
                middleName: '',
                lastName: '',
                firstNameAr: '',
                middleNameAr: '',
                lastNameAr: '',
                username: '',
                email: '',
                gender:  { id: undefined, name: 'Not Selected'},
                active: true,
                manager: {},
                structure: this.fromOrganaize ? this.structureProps : {},
                title: '',
                titleAr: '',
                profession: '',
                professionAr: '',
                salutation: '',
                isExternalContact: false,
                hasSingleApprovalPermission: false,
                isStructureReceiver: false,
                privacyLevel: {},
                isDesignatedPerson: false,
                isDefaultDesignatedPerson: false,
                // contactRole: {}
            }
            this.upsertUserDialogMode = 'new'
            this.upsertUserDialog = false
        },
        // asyncFindManager(query) {
        //     if (query == '') return;
        //     axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showCurrentEntity=true&search=' + query)
        //         .then(res => {
        //             this.managers = res.data;
        //             this.loading = false;
        //         })
        //         .catch(err => console.log(err));
        // },
        asyncFindManager(query) {
            if (query == '') return;

           var currentUserStructureId = this.user.structure?.id ?? null; 

           var structureId = this.structureId1 != 0 ? this.structureId1 : 
                    (currentUserStructureId != null && currentUserStructureId != 0) ? currentUserStructureId : 0

            axios.get(constants.baseApiUrl + 'StructureUser/GetUsersForEntity?searchUser='+ query +'&structureId=' + structureId)
                .then(res => {
                    this.managers = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str);
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        validateEmail(email) {
            // Check if email contains only spaces
            if (email.trim() === "")
                return false;

            // Check if email contains '@' character
            if (!email.includes('@'))
                return false;

            // Check if email contains '@@'
            if (email.includes('@@'))
                return false;

            if (email.includes('..'))
                return false;

            // Check if email contains spaces
            if (/\s/.test(email))
                return false;

            // Split email into local and domain parts
            const [localPart, domainPart] = email.split('@');

            // Check if local part is empty or starts/ends with a dot
            if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                return false;

            // Check if domain part is empty or starts/ends with a dot
            if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                return false;

            // Check if domain part contains a dot (to ensure a top-level domain is present)
            if (!domainPart.includes('.'))
                return false;

            // Regular expression to check for a valid domain
            const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

            // Regular expression to check for a valid IP address
            const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

            // Check if domain part is an invalid IP address
            if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                return true;
            else
                return false;

            return true;
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.searchUsers(false);
        },
        structureUserSelectChanged(item) {
            this.user.structure = item;
        }
    },
    filters: {
        limitText(text, maxSize){
            if (!text) return '';
            text = text.toString();

            if (text.length <= maxSize) {
                return text;
            }
            return text.substr(0, maxSize).trim() + ' ...';
        }
    },
    mounted: function () {
        let isFullAdmin = constants.isFullAdmin != null && constants.isFullAdmin !== false
        this.isAdmin = isFullAdmin
        this.canSeeAllCompanies = isFullAdmin
        this.enableSignWithOutPinCodeFeature = window.enableSignWithOutPinCodeFeature
        this.privacies = constants.privacies
        this.getCompaniesForUser()
        this.getLoginProviders()
        
        if(this.enableIntialFetchingUsers)
            this.searchUsers(true) 

        if(this.fromOrganaize) {
            this.user.structure = this.structureProps
        }
    },
    watch: {
        structure_id(newVal, oldVal) 
        {
            if (newVal !== oldVal) {
                this.searchUsers()
            }
        },

        onlyUsers()
        {
            this.searchUsers(false);
        },

        onlyDesignatedPersons()
        {
            this.searchUsers(false);
        },

        onlyDefaultDesignatedPersons()
        {
            this.searchUsers(false)
        }
    }
}
</script>

<style>
    .customTextarea{ 
        width: 100%;
        border-radius: 8px; 
        background-color: #eff2f5;
        outline: none;
        padding: 10px 19px 10px 15px;
        height: 46px;
        line-height: 1.7; 
        overflow: hidden !important; 
    }
    
    .cursor-input .v-input__slot {
        cursor: pointer !important;
    }

    .v-popper--theme-tooltip {
        max-width: 400px !important;
        word-break: break-word;
    }

</style>

<style scoped>
    .container {
    width: "100%";
    padding: 8px 16px;
    }

    .buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        margin-top: 8px;
    }

    .vtooltip {
        background-color: white;
        padding: 5px;
        border-radius: 25px;
    }

    .report-container .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }
    
    .report_header { 
        height: 50px;
        vertical-align: middle; 
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.015em;
        color: #667593;
    }

    .report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,  .report-container .v-data-table__wrapper table thead {
        background-color: #FFF;
        box-shadow: none;
    }

    .report-container {
        height: calc(100vh - 116px);
        display: flex;
        flex-direction: column;
        border-radius: 12px !important;
        overflow: auto;
        box-shadow: none !important;
    }

    .report-container .border-top {
        display: flex;
        flex-direction: column;
    }

    .report-container .v-toolbar {
        height: 80px !important;
        padding: 0;
    }
    .report-container .v-toolbar__content {
        height: 100% !important;
        padding: 24px !important;
    }
    
    img#ItemPreview {
        width: 100px;
        margin: 0.5rem 0;
    }

    .mdi-menu-down {
        filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
    }
    
    .v-dialog .v-toolbar__content {
        height: 100% !IMPORTANT;
    }

    .custom-tooltip {
        background-color: #2c2c2c;
        color: #fff;
        font-size: 13px;
        padding: 6px 12px;
        border-radius: 6px;
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
        max-width: 200px;
        text-align: center;
    }

    .hoverable-icon {
        transition: transform 0.2s ease;
    }

    .hoverable-icon:hover {
        transform: scale(1.2);
        cursor: pointer;
    }
   
</style> 